<template>
  <div class="tw:flex tw:items-center">
    <Star v-for="star in rating" :key="star" class="tw:size-4" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

import Star from '@/components/icons/Star.svg?component'

const props = defineProps({
  starsNumber: {
    type: Number,
    default: 0,
  },
})

const rating = computed(() => {
  const parsed = Number(props.starsNumber)
  const safeStars = Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : 0
  return Array.from({ length: safeStars }, (_, index) => index)
})
</script>
